import { useDispatch } from 'hooks/utils';
import { useActivity } from 'hooks/store';
import { Operation } from 'hooks/store/types';
import { ActionTypes, reactivateUserAccount } from 'store/account/enterprise';

export function useReactivateUserAccount(): Operation<(userId: string) => void> {
	const dispatch = useDispatch();

	const [{ loading, error }] = useActivity(ActionTypes.REACTIVATE_USER_ACCOUNT);

	function handler(userId: string) {
		dispatch(reactivateUserAccount(userId));
	}

	return [{ loading, error }, handler];
}
